import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp } from 'react-icons/fa';

export const ContactUs = () => {
  const whatsappNumber = "254759275981"; 
  const whatsappMessage = "Hello! I would like to inquire about your courses.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;


  return (
    <div className="min-h-screen">
      {/* Contact Header Section */}
      <div className="text-center py-16 px-4 text-black">
        <h1 className="text-4xl font-bold">Contact Us</h1>
        <p className="mt-4 text-lg">
          Reach out to Pacesetters College Institute for any inquiries or support.
        </p>
      </div>

      {/* Contact Form Section */}
      <div className="container mx-auto px-4 py-7">
        <div className="grid md:grid-cols-1 sm:grid-cols-1 gap-8">

          {/* Contact Info */}
          <div className="bg-white p-4 shadow-lg rounded-lg">
            <h2 className="text-2xl font-semibold text-secondary mb-6">Contact Information</h2>

            <ul className="space-y-4 text-gray-700">
              <li className="flex items-center">
                <FaMapMarkerAlt className="mr-3 text-secondary" size={25} />
                <strong>Address:</strong> KTDA plaza Nairobi, Kenya KTDA Farmers Building, 
                10th Floor Opposite Kenya Cinema
              </li>

              <li className="flex items-center">
                <FaPhone className="mr-3 text-secondary" size={25} />
                <strong>Phone:</strong> 0759 275981
              </li>

              <li className="flex items-center"  onClick={() => window.open(whatsappUrl)}>
                <FaWhatsapp className="mr-3 text-green-500 cursor-pointer" size={25}/>
                <strong>WhatsApp:</strong> Message us on WhatsApp
              </li>

              <li className="flex items-center">
                <FaEnvelope className="mr-3 text-secondary" size={25}/>
                <strong>Email:</strong> pacesetterscollege2022@gmail.com
              </li>

              <li className="flex items-center">
                <FaClock className="mr-3 text-secondary" size={25} />
                <strong>Working Hours:</strong> Mon - Sat, 9am - 5pm, Sun 1pm - 5pm
              </li>
            </ul>

            {/* Embedded Map */}
            <div className="mt-8">
              <h3 className="text-lg font-semibold text-secondary">Visit Us:</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1994.40594354978!2d36.8255583!3d-1.286953!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f11b7174dc0d1%3A0x63eb206f98f6d404!2sKTDA%20FAMERS%20BUILDING!5e0!3m2!1ssw!2ske!4v1728651459983!5m2!1ssw!2ske"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Google Map"
              ></iframe>
            </div>
          </div>
          {/* Form */}
          <div className="bg-white p-8 shadow-shadow1 rounded-lg">
            <h2 className="text-2xl font-semibold text-secondary mb-6">
              Send us a Message
            </h2>
            <form className="space-y-4">
              <div>
                <label
                  className="block text-gray-700 font-bold mb-2"
                  htmlFor="name"
                >
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary"
                  placeholder="Enter your name"
                />
              </div>
              <div>
                <label
                  className="block text-gray-700 font-bold mb-2"
                  htmlFor="email"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary"
                  placeholder="Enter your email"
                />
              </div>
              <div>
                <label
                  className="block text-gray-700 font-bold mb-2"
                  htmlFor="message"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  className="w-full h-32 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary"
                  placeholder="Enter your message"
                ></textarea>
              </div>
              <div>
                <button
                  type="submit"
                  className="w-full bg-primary text-white py-2 px-4 rounded-lg hover:bg-opacity-90 transition-all"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    
  );
};
